import { Collapse, Tag, Typography } from 'antd';
import { CaretDownOutlined, CaretRightOutlined, CheckOutlined } from '@ant-design/icons';
import { createUseStyles } from 'react-jss';

const { Text } = Typography;

const useStyles = createUseStyles({
  compact: {
    '& .ant-collapse-item > .ant-collapse-header': {
      padding: '0 !important',
      alignItems: 'center',
    },
    '& .ant-collapse-content > .ant-collapse-content-box': {
      padding: '8px 0 8px 18px !important',
    },
  },
});

interface PoolPillListProps {
  methods: { id: string; name: string }[];
  selectedMethodId?: string;
}

const PoolPillList = ({ methods, selectedMethodId }: PoolPillListProps) => {
  if (methods.length === 0) {
    return (
      <Text type="secondary" italic style={{ fontSize: 11 }}>
        empty
      </Text>
    );
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
      {methods.map(({ id, name }) => {
        const isSelected = id === selectedMethodId;
        return (
          <Tag key={id} color={isSelected ? 'blue' : undefined} style={isSelected ? { fontWeight: 500 } : undefined}>
            {isSelected ? <CheckOutlined style={{ marginRight: 4 }} /> : null}
            {name}
          </Tag>
        );
      })}
    </div>
  );
};

export interface CollapsiblePoolProps {
  panelKey: string;
  label: React.ReactNode;
  methods: { id: string; name: string }[];
  selectedMethodId?: string;
}

export const CollapsiblePool = ({ panelKey, label, methods, selectedMethodId }: CollapsiblePoolProps) => {
  const styles = useStyles();
  return (
    <Collapse
      ghost
      className={styles.compact}
      expandIcon={({ isActive }) =>
        isActive ? (
          <CaretDownOutlined style={{ fontSize: 10, color: 'rgba(0,0,0,0.45)' }} />
        ) : (
          <CaretRightOutlined style={{ fontSize: 10, color: 'rgba(0,0,0,0.45)' }} />
        )
      }
    >
      <Collapse.Panel
        key={panelKey}
        header={
          <Text type="secondary" strong style={{ fontSize: 12 }}>
            {label}
          </Text>
        }
      >
        <PoolPillList methods={methods} selectedMethodId={selectedMethodId} />
      </Collapse.Panel>
    </Collapse>
  );
};
